module.exports = __webpack_public_path__ + "img/SE.57ad7f71.svg";